import { render, staticRenderFns } from "./ReservguidancePage.vue?vue&type=template&id=1c1b9eb1&scoped=true&"
import script from "./ReservguidancePage.vue?vue&type=script&lang=js&"
export * from "./ReservguidancePage.vue?vue&type=script&lang=js&"
import style0 from "./ReservguidancePage.vue?vue&type=style&index=0&id=1c1b9eb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1b9eb1",
  null
  
)

/* custom blocks */
import block0 from "./ReservguidancePage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports